import request, { retryRequest } from '@/utils/request'
import * as Checkout from '@/interfaces/checkout'
import { AxiosPromise } from 'axios'
import { IFamiPortCodeResponse, ITransferSerialResponse } from '@/interfaces/checkout'
import { IApiResponse } from '@/interfaces'

export function getCouponStatus (data: Checkout.IGetCPStatusRequest): AxiosPromise<Checkout.IGetCPStatusResponse> {
  return request({
    url: '/204_GetCPStatus_v2.php',
    method: 'post',
    data
  })
}
// /600_famiport_get_code_v2_tok.php
export function getTransferSerial (data: Checkout.ITransferSerialRequest): AxiosPromise<ITransferSerialResponse> {
  /*
  return request({
    url: '/190_GetTransferSerial_v2_tok.php',
    method: 'post',
    data
  })
  */
  return Promise.reject(new Error('The method is obsoleted.'))
}

export function getFamiPortCode (data: Checkout.IFamiPortCodeRequest): AxiosPromise<IFamiPortCodeResponse> {
  /*
  return request({
    url: '/600_famiport_get_code_v2_tok.php',
    method: 'post',
    data
  })
  */
  return Promise.reject(new Error('The method is obsoleted.'))
}

export function getWebAppCaps (data: Checkout.IWebAppCapsRequest): AxiosPromise<any> {
  return request({
    url: '/900_WebNewAppCaps.php',
    method: 'post',
    data
  })
}

export function setOrderInfo (data: Checkout.IOrderRequest): AxiosPromise<IApiResponse> {
  return retryRequest({
    url: '/128_SetOrderInfoServer_v3_tok.php',
    method: 'post',
    timeout: 60000,
    data
  })
}

export function uploadFileToServer (data: Checkout.IUploadImageServerRequest, fileName: string, serverUrl: string | null): AxiosPromise<any> {
  const formData = new FormData()
  formData.append('token', data.token)
  formData.append('app_index', data.app_index.toString())
  formData.append('destDir', data.destDir)
  formData.append('login', data.login)
  formData.append('pwd', data.pwd)
  formData.append('file', data.file, fileName)

  if (serverUrl == null || (serverUrl !== null && /nuphoto/g.test(serverUrl))) {
    return request({
      baseURL: serverUrl || 'https://nuphoto.us/',
      url: '/118_UploadImageServer_tok.php',
      method: 'post',
      data: formData,
      transformRequest: [], // Replace default transformRequest
      withCredentials: false
    })
  } else {
    return Promise.reject(new Error('上傳伺服器失敗。'))
  }
}

export function getNuCoinInfo (data: Checkout.IGetNuCoinInfoRequest): AxiosPromise<Checkout.IGetNuCoinInfoResponse> {
  return request({
    url: '/nucoin_info.php',
    method: 'post',
    data
  })
}
